import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';

declare let $: any;

@Component({

  selector: 'app-user-chart',

  templateUrl: './user-chart.component.html',

  styleUrls: ['./user-chart.component.css']

})

export class UserChartComponent implements OnInit {

  list_StrChart: any = [];

  list_Chart4Breadcrumb: any = [];

  bChartOption: boolean = false;

  selectedNode: any = {};

  breadCrumb: string = '';

  mdl_Search: FormGroup = this._formBuilder.group({

    iSystemUser: this._gurd.decrypt(localStorage.getItem('ID')!),

    strSession: this._gurd.decrypt(localStorage.getItem('Session')!),

  })

  constructor(

    private _toolTip: NotificationService,

    private _formBuilder: FormBuilder,

    private _gurd: GurdServiceService,

    private _other: OtherService,

    private _route: ActivatedRoute

  ) { }

  ngOnInit(): void {

    this.initialChart();

  }

  treeOperation(node: any) {

    this.selectedNode = {

      strChart: node.id,

      strComment: node.text,

      strChartParent: node.id == 0 ? '-1' : node.parent,

      children: node.children,

      parent: [node.id, ...node.parents],

      iSort: 0

    }

    this.getBreadcrumb(this.selectedNode.parent)

    this.bChartOption = true;

  }

  async initialChart() {

    this._other.Showspinner();

    let response = await axios.post(`UserManager_Chart_List`, this._other.stringNumberToNumber(this.mdl_Search.value));

    let res = JSON.parse(response.data.toString());

    this._other.nonespinner();

    if (res.iResult == 0) return this._toolTip.showError(res.strError)

    $("#jstree").jstree("destroy");

    $('#jstree').on("changed.jstree", (e: any, data: any) => {

      this.treeOperation(data.instance.get_node(data.selected[0]));

    });

    this.list_Chart4Breadcrumb = JSON.parse(response.data.toString());

    this.list_StrChart = res;

    this.mapDataToTreeStructure(res, '0');


  }

  mapDataToTreeStructure(res: any, target: any) {

    let nodeById = new Map();

    let rootNodes: any = [];

    res.forEach((node: any) => {

      node.children = []; // define children property for each node

      nodeById.set(node.strChart, node); // collect nodes by their Ids

    });

    res.forEach((node: any) => {

      let parentNode = nodeById.get(node.strParentCode);

      if (parentNode) parentNode.children.push(node);

      else rootNodes.push(node); // if no parent is found, then it's a root node.

    });

    //  to sort nodes by iSort

    const sortChildrenByISort = (obj: any) => {

      if (Array.isArray(obj.children) && obj.children.length > 0) {

        obj.children.sort((a: any, b: any) => a.iSort - b.iSort);

        obj.children.forEach(sortChildrenByISort);

      }

    };

    // Sort the rootNodes and their children

    rootNodes.sort((a: any, b: any) => a.iSort - b.iSort);

    rootNodes.forEach(sortChildrenByISort);

    let convertToTreeData = (nodes: any) => {

      return nodes.map((node: any) => {

        let children = convertToTreeData(node.children);

        return {

          text: node.strComment,

          id: node.strChart,

          icon: children.length ? null : "jstree-file",   // icon added only for leaf nodes

          children: children.length ? children : null,

          state: node.strChart == target ? { "opened": true, "selected": false, "disabled": false } : { "opened": false },


        };

      });

    };

    let treeData = convertToTreeData(rootNodes);

    $('#jstree').jstree({

      core: {

        "themes": { "stripes": true },

        'data': treeData

      }

    });

  }

  getBreadcrumb(parents: []) {

    this.breadCrumb = '';

    let breadCrumb: any = [];

    parents.forEach((a: any) => {

      const item = this.list_Chart4Breadcrumb.filter((b: any) => b.strChart == a)[0];

      if (item != undefined) breadCrumb.push(item)

    })

    let sortedBreadcrumb = breadCrumb.sort((a: any, b: any) => {

      return a.strChart.localeCompare(b.strChart);

    });

    sortedBreadcrumb.forEach((a: any, index: number) => {

      if (index != sortedBreadcrumb.length && index != 0) this.breadCrumb += ' / ' + a.strComment

      else this.breadCrumb += a.strComment

    })

  }

  async nodeOperation(type: string, text?: string, iSort?: number | string) {

    // افزودن 

    if (type === 'new') {

      var model = {

        iSystemUser: this._gurd.decrypt(localStorage.getItem('ID')!),

        strSession: this._gurd.decrypt(localStorage.getItem('Session')!),

        strParentCode: this.selectedNode.strChart,

        strComment: text,

        iSort: iSort == '' ? 0 : iSort

      }

      this._other.Showspinner();

      let response = await axios.post(`UserManager_Chart_Save`, this._other.stringNumberToNumber(model));

      let res = JSON.parse(response.data.toString());

      this._other.nonespinner();

      if (res.iResult == 0) return this._toolTip.showError(res.strError)

      this._toolTip.showSuccess('با موفقیت اضافه شد');

      this.bChartOption = false;

      this.initialChart();

    }

    // ویرایش

    else if (type === 'edit') {

      // text: `آیا از ویرایش ${this.selectedNode.strComment} اطمینان دارید؟`,

      let model = {

        iSystemUser: this._gurd.decrypt(localStorage.getItem('ID')!),

        strSession: this._gurd.decrypt(localStorage.getItem('Session')!),

        strChart: this.selectedNode.strChart,
        
        strComment: text,

        iSort: iSort == '' ? 0 : iSort

      }

      this._other.Showspinner();

      let response = await axios.post(`UserManager_Chart_Edit`, this._other.stringNumberToNumber(model));

      let res = JSON.parse(response.data.toString());

      this._other.nonespinner();

      if (res.iResult == 0) return this._toolTip.showError(res.strError)

      this._toolTip.showSuccess('با موفقیت اضافه شد');

      this.bChartOption = false;

      this.initialChart();

    }

    // حذف

    else {

      // text: `آیا از حذف ${this.selectedNode.strComment} اطمینان دارید؟`,

      let model = {

        iSystemUser: this._gurd.decrypt(localStorage.getItem('ID')!),

        strSession: this._gurd.decrypt(localStorage.getItem('Session')!),

        strChart: this.selectedNode.strChart,

      }

      this._other.Showspinner();
      
      let response = await axios.post(`UserManager_Chart_Delete`, this._other.stringNumberToNumber(model));

      let res = JSON.parse(response.data.toString());

      this._other.nonespinner();

      if (res.iResult == 0) return this._toolTip.showError(res.strError)

      this._toolTip.showSuccess('با موفقیت حذف شد');

      this.bChartOption = false;

      this.initialChart();

    }

  }

  getNodeIndex(event: any) {

    setTimeout(() => {

      if (event.target.innerText == '') return '';

      this.selectedNode.iSort = this.list_StrChart.filter((a: any) => { return a.strComment == event.target.innerText })[0].iSort;

      return;


    }, 1);

  }

}
